import { ONE_DAY_IN_SECONDS } from "@mirage/shared/util/constants";
import type { LargeKvStore } from "@mirage/storage/large-kv-store/interface";
import { getTodaysDateString, type DashTrialInfo } from "./utils";

type DashTrialInfoContents = {
  dashTrialInfo: DashTrialInfo;
  dateLastUpdated: string;
};

const CACHED_DASH_TRIAL_INFO_KEY = "DashTrialInfo";

const CACHE_EXPIRATION_TIME_IN_SECONDS = ONE_DAY_IN_SECONDS / 4;

export class DashTrialInfoCache {
  public constructor(private readonly store: LargeKvStore) {}

  public async getDashTrialInfo(): Promise<DashTrialInfoContents | undefined> {
    const cachedDashTrialInfo = await this.store.get(
      CACHED_DASH_TRIAL_INFO_KEY,
    );
    if (cachedDashTrialInfo) {
      return JSON.parse(cachedDashTrialInfo) as DashTrialInfoContents;
    }
    return undefined;
  }

  public async setDashTrialInfo(dashTrialInfo: DashTrialInfo): Promise<void> {
    await this.store.set(
      CACHED_DASH_TRIAL_INFO_KEY,
      JSON.stringify({
        dashTrialInfo,
        dateLastUpdated: getTodaysDateString(),
      }),
      CACHE_EXPIRATION_TIME_IN_SECONDS,
    );
  }
}
